import React, { useEffect, useState } from "react";
import { api } from "../../lib/backofficeApi";

const DAYS = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];
const LABELS = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"];
const emptyWeek = () => DAYS.map(day => ({ day, windows: [] }));

export default function WhatsAppResponseHours({ clinicId }) {
  const [value, setValue] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [notice, setNotice] = useState("");
  useEffect(() => {
    let active = true;
    api(`/clinic/${clinicId}`).then(clinic => {
      if (!active) return;
      const saved = clinic.whatsapp_response_schedule;
      setValue({ mode: saved?.mode || "always", timezone: saved?.timezone || "America/Mexico_City",
        week: DAYS.map(day => saved?.week?.find(d => d.day === day) || { day, windows: [] }) });
    }).catch(e => { if (active) setError(e.message); });
    return () => { active = false; };
  }, [clinicId]);
  const change = next => { setValue(next); setNotice(""); setError(""); };
  const windows = (index, next) => change({ ...value, week: value.week.map((d, i) => i === index ? { ...d, windows: next } : d) });
  async function save() {
    if (busy) return;
    setBusy(true); setError(""); setNotice("");
    try {
      await api(`/clinic/${clinicId}`, { whatsapp_response_schedule: value }, "PATCH");
      const clinic = await api(`/clinic/${clinicId}`);
      const saved = clinic.whatsapp_response_schedule;
      if (JSON.stringify(saved) !== JSON.stringify(value)) throw new Error("El horario guardado no coincide. Recarga antes de volver a guardar.");
      setNotice("Horario guardado y comprobado.");
    } catch (e) { setError(e.message); }
    finally { setBusy(false); }
  }
  return <section className="bo-scope bo-assistant" aria-label="Horario de respuesta de Gina en WhatsApp">
    <h2>Cuándo responde Gina en WhatsApp</h2>
    <p>Fuera de estos intervalos, los mensajes quedan disponibles para tu equipo. Este horario no modifica las horas de consulta ni los recordatorios.</p>
    {error && <p className="bo-error" role="alert">{error}</p>}
    {!value ? <p>Cargando horario…</p> : <fieldset disabled={busy} style={{ border: 0, padding: 0 }}>
      <label>Modo de respuesta
        <select aria-label="Modo de respuesta" value={value.mode} onChange={e => change({ ...value, mode: e.target.value })}>
          <option value="always">Siempre (24 horas)</option><option value="scheduled">Solo en los intervalos indicados</option><option value="paused">Pausada</option>
        </select>
      </label>
      {value.mode === "scheduled" && <>
        <label>Zona horaria <input aria-label="Zona horaria de respuestas" value={value.timezone} onChange={e => change({ ...value, timezone: e.target.value })} placeholder="America/Mexico_City" /></label>
        <p>Formato 24 horas. Usa 24:00 para el final del día. Para responder durante la noche, añade un intervalo en cada día.</p>
        {(value.week || emptyWeek()).map((day, index) => <div key={day.day} style={{ padding: "12px 0", borderBottom: "1px solid #d5e4e1" }}>
          <strong>{LABELS[index]}</strong>
          {!day.windows.length && <p>Sin respuestas automáticas este día.</p>}
          {day.windows.map((w, wi) => <div key={wi} style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center", margin: "6px 0" }}>
            <input aria-label={`${LABELS[index]} inicio ${wi + 1}`} value={w.start} placeholder="17:00" maxLength={5} style={{ width: 90 }} onChange={e => windows(index, day.windows.map((x, j) => j === wi ? { ...x, start: e.target.value } : x))} />
            <span>a</span>
            <input aria-label={`${LABELS[index]} fin ${wi + 1}`} value={w.end} placeholder="24:00" maxLength={5} style={{ width: 90 }} onChange={e => windows(index, day.windows.map((x, j) => j === wi ? { ...x, end: e.target.value } : x))} />
            <button type="button" onClick={() => windows(index, day.windows.filter((_, j) => j !== wi))}>Quitar intervalo</button>
          </div>)}
          <button type="button" disabled={day.windows.length >= 8} onClick={() => windows(index, [...day.windows, { start: "09:00", end: "17:00" }])}>Añadir intervalo · {LABELS[index]}</button>
        </div>)}
      </>}
      <div className="bo-actions"><button type="button" className="bo-primary" onClick={save}>{busy ? "Guardando…" : "Guardar horario de respuestas"}</button></div>
      {notice && <p role="status">{notice}</p>}
    </fieldset>}
  </section>;
}
